import glamorous from 'glamorous';
import { Text as Header } from 'pp-react';

export const Container = glamorous.div({
  width: '92%',
  maxWidth: '1300px',
  textAlign: 'center',
  margin: '5px auto 50px auto',

  '@media(max-width: 767px)': {
    margin: '10px auto 25px auto',
  },
});

export const Block = glamorous.div({
  width: '85%',
  maxWidth: '1300px',
  margin: '15px auto 15px auto',

  '@media(max-width: 480px)': {
    width: '100%',
    margin: '10px auto 10px auto',
  },
});

export const Title = glamorous(Header)({
  padding: '24px 0px 30px 0px',
  textAlign: 'center',

  '@media(max-width: 767px)': {
    fontSize: '28px',
    lineHeight: '1.2',
  },
});

export const Images = glamorous.div({});

export const Image = glamorous.img({
  margin: 'auto',
  padding: '0px 20px 40px 20px',

  '@media(max-width: 1199)': {
    padding: '0px 10px 20px 10px',
  },
});

export const Slide = glamorous.div({
  width: '50%',
  textAlign: 'center',
  margin: 'auto',

  '@media(max-width: 479px)': {
    width: '70%',
  },
});

export const Circle = glamorous.span({
  border: '1px solid #c0c0c0',
  padding: '4px 11px',
  borderRadius: '50%',
  float: 'left',
  fontWeight: 'bold',
  marginRight: '20px',
});

export const Text = glamorous(Header)({
  textAlign: 'left',
  padding: '0px 0px 0px 50px',

  '@media(max-width: 767px)': {
    padding: '0px 0px 0px 30px',
  },
});

export const Button = glamorous.a({
  borderRadius: '25px',
  padding: '15px 60px 15px 60px',
  margin: 'auto',
});
